import React, { useState, useEffect } from "react";
import * as documentService from "../services/documentService";
import * as surveyService from "../services/surveyService";
import * as helper from "../services/helper";
import Layout from "./Layout";
import QuestionCard from "./common/questionCard";
import { useRouteMatch } from "react-router-dom";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { useHistory, useLocation, useParams } from "react-router-dom";

const SurveyForm = () => {
  const [form, setForm] = useState({});
  const [documentLoaded, setDocumentLoaded] = useState({
    template: false,
    icon: "fas fa-paper-plane pr-3",
  });
  const [schema, setSchema] = useState({});
  const [errors, setErrors] = useState({});
  const [document, setDocument] = useState({
    header: { p: [] },
    components: [],
  });
  const match = useRouteMatch("/survey/:id/:serviceName");
  const history = useHistory();

  useEffect(() => {
    documentService
      .getDocument(match.params.id)
      .then(({ data: response }) => {
        setDocument(response);
        setSchema(createSchema(response.components));
        setDocumentLoaded({ ...documentLoaded, template: true });
      })
      .catch((err) =>
        setDocumentLoaded({ ...documentLoaded, template: false })
      );

    // toast.configure();
    // const getDateStr = () => {
    //   const dt = new Date();
    //   return dt.toLocaleString("es-DO");
    // };
    // setDateString(getDateStr());
    // const interval = setInterval(() => {
    //   setDateString(getDateStr());
    // }, 1000);
    //setIntervalVariable(interval);
  }, []);

  function resetForm() {
    const clear = { ...form };
    for (const p in clear) {
      clear[p] = "";
    }
    setForm(clear);
  }

  function validate() {
    const options = { abortEarly: false };
    const { error } = Joi.validate(form, schema, options);

    if (!error) return null;

    const errors = {};
    for (let err of error.details) {
      errors[err.path[0]] = err.message;
    }
    return errors;
  }

  function createSchema(components) {
    const _schema = {};
    components.forEach((comp) => {
      if (comp.validation) {
        _schema[comp.name] = helper.createJoiValidationChain(comp.validation);
      }
    });
    return _schema;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validate();
    setErrors(errors || {});

    if (errors) return false;

    try {
      setDocumentLoaded({
        ...documentLoaded,
        icon: "fas fa-circle-notch fa-spin",
      });

      await surveyService.saveForm(
        match.params.id,
        match.params.serviceName,
        form
      );
      resetForm();

      history.push(`/done/${match.params.id}/${match.params.serviceName}`);
      //toast.success("Mensaje enviado de forma satisfactoria");
    } catch {
      toast.error("Falló el envío del mensaje");
    } finally {
      setDocumentLoaded({ ...documentLoaded, icon: "fas fa-paper-plane pr-3" });
    }

    return true;
  };

  const handleChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  if (!documentLoaded.template)
    return (
      <React.Fragment>
        <h1 className="text-center mb-4 pr-3 font-weight-bold">
          No existe ningún formulario
        </h1>
      </React.Fragment>
    );

  return (
    <Layout>
      <h1 className="mb-4 pr-3 font-weight-bold">{document.header.title}</h1>
      {document.header.p.map((p) => (
        <p key={p}>{p}</p>
      ))}
      <form onSubmit={handleSubmit}>
        {document.components.map((component) => (
          <QuestionCard
            key={component.name}
            item={component}
            value={form[component.name]}
            error={errors[component.name]}
            onChange={handleChange}
          />
        ))}
        <div className="text-right">
          <button
            className="btn btn-success px-3 text-uppercase mb-5"
            type="submit"
          >
            <i className={documentLoaded.icon}></i>Enviar
          </button>
        </div>
      </form>
    </Layout>
  );
};

export default SurveyForm;
